import script from "./EventPostsView.vue?vue&type=script&setup=true&lang=js"
export * from "./EventPostsView.vue?vue&type=script&setup=true&lang=js"

import "./EventPostsView.vue?vue&type=style&index=0&id=2dc69ca0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dc69ca0"]])

export default __exports__